export default __webpack_public_path__ + "static/media/me-icon.1ed672df.webp";